import { Injectable } from '@angular/core';
import { collection, collectionData, Firestore, orderBy, query, where } from '@angular/fire/firestore';
import { map, Observable, of, shareReplay, switchMap } from 'rxjs';

import { AgreementWithId } from '@innersight-os/shared/firestore-interfaces';
import { UsersService } from '../users/users.service';

@Injectable({
  providedIn: 'root'
})
export class AgreementsService {
  constructor(
    private db: Firestore,
    private users: UsersService,
  ) {}

  allAgreements$: Observable<AgreementWithId[]> = collectionData<AgreementWithId>(
    // eslint-able-next-line @typescript-eslint/no-explicit-any
    collection(this.db, 'agreements') as any,
    {idField: 'id'},
  )

  // eslint-able-next-line @typescript-eslint/consistent-indexed-object-style
  agreementsById$: Observable<{[opId: string]: AgreementWithId}> = this.users.iAmAnAdmin$.pipe(
    switchMap(iAmAnAdmin =>
      (iAmAnAdmin ? this.allAgreements$ : of([] as AgreementWithId[])).pipe(
        map(agreements => Object.fromEntries(agreements.map(a => [a.id, a])))
      )
    ),
    shareReplay({bufferSize: 1, refCount: true})
  )

  getTeamAgreements(teamId: string): Observable<AgreementWithId[]> {
    return collectionData(
      query(
        // eslint-able-next-line @typescript-eslint/no-explicit-any
        collection(this.db, 'agreements') as any,
        where('teams', 'array-contains', teamId),
        orderBy('startDate', 'desc'), // firebase index for agreements and startDate is descending only at the moment
      ),
      {idField: 'id'},
    ) as Observable<AgreementWithId[]>
  }
}
